import { Delete, Get, Post, PostFormData } from "../Request/Api";

export default {
  state: {
    pageNum: null,
    Blogs: [],
    FeaturedBlogs: [],
    ViewBlog: null,
    relatedBlog: null,
    BlogComments: [],
  },
  getters: {
    GetBlogs(state: any) {
      if (state.Blogs.length) {
        return state.Blogs;
      }
    },
    GetLatestBlogs(state: any) {
      if (state.Blogs.length) {
        return state.Blogs;
      }
    },
    GetBlogComments(state: any) {
      return state.BlogComments;
    },
    relatedBlog(state: any) {
      return state.relatedBlog;
    },
    GetFeaturedBlogs(state: any) {
      return state.FeaturedBlogs;
    },
    GetViewBlog(state: any) {
      return state.ViewBlog;
    },
  },
  actions: {
    setBlogView({ commit }: any, payload: any) {
      console.log(payload);
      commit("SetBlogView", payload);
    },

    async GetBlogs({ commit }: any, payload: any) {
      return await Get(
        `Blog/GetBlog/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}&filters=[{ Key: "Visibility", Value: "Show" }]`
      ).then((res: any) => {
          commit("SetBlogs", res.data.Data.List);
        return res;
      });
    },
    async GetLatestBlogs({ commit }: any, payload: any) {
      return await Get(
        `Blog/GetBlog/1?pageSize=5`
      ).then((res: any) => {
          commit("SetBlogs", res.data.Data?.List);
        return res;
      });
    },
    async GetBlogById({ commit }: any, payload: any) {
      return await Get(`Blog/GetBlogById/${payload}`).then((res: any) => {
        commit("SetBlogView", res.data.Data.Blog);
        commit("SetRelatedBlogView", res.data.Data.data);
      });
    },
    async GetBlogComments({ commit }: any, payload: any) {
      return await Get(
        `Blog/GetBlogComments?search=null&isWebApp=false&page=${payload.page}&pageSize=-1&blogId=${payload.blogId}`
      ).then((res: any) => {
        commit("SetBlogComments", res.data.Data.List);
        return res.data.Data;
      });
    },
    async GetFeaturedBlogs({ commit }: any, payload: any) {
      return await Get("Blog/GetFeaturedBlog").then((res: any) => {
        commit("SetFeaturedBlogs", res.data.Data);
        return res.data.Data;
      });
    },
    async AddComment({ commit }: any, payload: any) {
      return await Post("Blog/AddComment", payload).then((res: any) => {
        return res.data;
      });
    },
    async EditComment({ commit }: any, payload: any) {
      return await Post(`Blog/EditBlogComment`, payload).then((res: any) => {
        return res.data;
      });
    },
    async DeleteBlogComment({ commit }: any, payload: any) {
      return Delete(`Blog/DeleteBlogComment/${payload}`).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetPageNum(state, pageNum) {
      state.pageNum = pageNum;
    },
    SetBlogs(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.Banner =
          x.Banner != null && x.Banner != undefined && x.Banner != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.Banner
            ? x.Banner
            : x.Banner;
        x.SubmittedByProfileImage =
          x.SubmittedByProfileImage != null &&
          x.SubmittedByProfileImage != undefined &&
          x.SubmittedByProfileImage != ""
            ? x.SubmittedByProfileImage
            : x.SubmittedByProfileImage;
        return x;
      });
    state.Blogs = payload.length !== 0 ? payload : []
    },
    SetBlogComments(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.SubmittedByProfileImage =
          x.SubmittedByProfileImage != null &&
          x.SubmittedByProfileImage != undefined &&
          x.SubmittedByProfileImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.SubmittedByProfileImage
            ? x.SubmittedByProfileImage
            : x.SubmittedByProfileImage;
        return x;
      });
      state.BlogComments = payload;
    },
    SetFeaturedBlogs(state: any, payload: any) {
      state.FeaturedBlogs = payload.map((x: any) => {
        // x.Blog.Banner = process.env.VUE_APP_IMG_URL + x.Blog.Banner;
        x.Blog.Banner = x.Blog.Banner;
        return x;
      });
    },
    SetBlogView(state: any, payload: any) {
      console.log(payload);
      // payload.Banner = process.env.VUE_APP_IMG_URL + "/" + payload.Banner;
      payload.Banner = payload.Banner;
      payload.SubmittedByProfileImage = payload.SubmittedByProfileImage;
        // process.env.VUE_APP_IMG_URL + "/" + payload.SubmittedByProfileImage;
      state.ViewBlog = payload;
    },
    SetRelatedBlogView(state: any, payload: any) {
      payload = payload.map((x: any) => {
        // x.Banner = process.env.VUE_APP_IMG_URL + "/" + x.Banner;
        x.Banner = x.Banner;
        return x;
      });
      state.relatedBlog = payload;
    },
  },
};
